import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { findNextSlide } from '../../actions';
import { general } from '../../data';
import { trackAction } from '../../utils';

const imgs = general.imgs;

const mapDispatchToProps = dispatch => {
  return {
    onNextSlide: id => {
      dispatch(findNextSlide(id))
    }
  }
}

class Button extends Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    const type = this.props.type;
    const action = type ? `slide-change:${type}` : 'slide-change';
    trackAction(action, this.props.goto);
    this.props.onNextSlide(this.props.goto);
  }

  render() {
    let disabled;
    let image;
    let overlay;

    if(this.props.text === 'Reset'){
      disabled = !this.props.game_info.answers.length ? 'disabled' : '';
    } else {
      disabled = !this.props.active ? 'disabled' : '';
    }

    if(this.props.type === 'reset') {
      image = <img src={ imgs.refresh_icon }/>
    }

    const btnClassNames = classNames(
      'gm-slide__button',
      {
        'gm-slide__button--reset': this.props.type === 'reset',
        'gm-slide__button--single': this.props.btn_obj.length === 1,
        'gm-slide__button--start': this.props.text.includes('of 4')
      }
    )

    return (
      <button className={ btnClassNames } disabled={ disabled } onClick={ this.handleClick }>
        { image }
        { this.props.text }
      </button>
    );
  }
}

export default connect(null, mapDispatchToProps)(Button);



// WEBPACK FOOTER //
// ./src/components/Shared/Button.js